import React, { useEffect } from "react";
import { X } from "lucide-react";

export const Modal = ({ open, onClose, children, testId, maxWidth = "max-w-lg" }) => {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      data-testid={testId}
    >
      <div
        className="absolute inset-0 bg-kirana-brown/70 backdrop-blur-sm"
        onClick={onClose}
      />
      <div
        className={`animate-card-in relative z-10 w-full ${maxWidth} max-h-[90vh] overflow-y-auto scrollbar-thin rounded-lg border-[3px] border-kirana-brown bg-card paper-grain hard-shadow`}
      >
        <button
          data-testid="modal-close"
          onClick={onClose}
          className="absolute right-3 top-3 z-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-kirana-brown bg-kirana-cream text-kirana-brown transition-colors hover:bg-kirana-red hover:text-white"
        >
          <X className="h-4 w-4" strokeWidth={3} />
        </button>
        {children}
      </div>
    </div>
  );
};
